<template>
  <div :style="{ padding: '30px' }">
    <h3>{{ this.$route.params.titulo }}</h3>
    <br />
    <div
      v-for="n in repetir"
      :key="n"
      style="border: #e6e6e6; border-radius: 10px"
    >
      <div
        style="display: flex; align-items: center"
        @click="toggleCollapse(n - 1)"
      >
        <v-icon>
          {{ isCollapsed[n - 1] ? 'mdi-menu-up' : 'mdi-menu-down' }}</v-icon
        >
        <button style="padding: 10px; text-align: justify">
          {{ chavesAvaliados[n - 1] }}
        </button>
      </div>
      <div v-if="isCollapsed[n - 1]">
        <div v-for="k in descricoes" :key="k">
          <QuestionSet
            :visualizar="true"
            :sm="true"
            :nome-membros="chavesAvaliados"
            :titulo="descricaoClassificacao[k - 1]"
            :pergunta="listaQuestoes[k - 1]"
            :quantidade="listaQuestoes[k - 1].length"
            :quantidade-linhas="chavesAvaliados.length"
            :notas-recebidas-objeto="
              dados[chavesAvaliados[n - 1]][descricaoClassificacao[k - 1]]
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import QuestionSet from '@/components/QuestionSet.vue';
import store from '@/store/store';
/* eslint-disable */
const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    QuestionSet,
  },
  async mounted() {
    for (let i = 0; i < this.repetir; i++) {
      this.isCollapsed.push(false);
    }
    await this.fetch();
    this.descricoes = this.descricaoClassificacao.length;

    this.descricaoClassificacao.forEach((classi) => {
      this.listaQuestoes.push(
        Object.keys(this.dados[this.chavesAvaliados[0]][classi])
      );
    });

    console.log(this.dados);
  },
  data: () => ({
    chavesAvaliados: null,
    vazio: false,
    repetir: 0,
    descricoes: 0,
    titulo: null,
    listaQuestoes: [],
    descricaoClassificacao: [],
    notasRecebidas: null,
    dados: null,
    isCollapsed: [],
  }),
  methods: {
    async fetch() {
      var notasRecebidas = {};
      var retorno = {};
      var listaQuestoes = [];
      var descricaoClassificacao = [];
      let nomeMembrosAvaliados = [];
      try {
        const response = await axios.get(
          `${API_URL}/avaliacoes/formulario/visualizar/${this.$route.params.id}/${this.$route.params.id_proj}`,
          {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          }
        );
        this.titulo = response.data.titulo;
        var dados = response.data;
        this.vazio = dados.tb_avaliacao_item.length <= 0;
        dados.tb_avaliacao_item.forEach((dado) => {
          if (
            !nomeMembrosAvaliados.includes(
              dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario
                .nome
            )
          ) {
            this.repetir++;
            nomeMembrosAvaliados.push(
              dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario
                .nome
            );
            retorno[
              // eslint-disable-next-line max-len
              dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario.nome
            ] = {};
          }
          if (
            !(
              dado.tb_item_de_avaliacao.tb_classificacao.descricao in
              retorno[
                dado
                  .tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario
                  .nome
              ]
            )
          ) {
            retorno[
              // eslint-disable-next-line max-len
              dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario.nome
            ][dado.tb_item_de_avaliacao.tb_classificacao.descricao] = {};
          }
          if (
            !descricaoClassificacao.includes(
              dado.tb_item_de_avaliacao.tb_classificacao.descricao
            )
          ) {
            descricaoClassificacao.push(
              dado.tb_item_de_avaliacao.tb_classificacao.descricao
            );
          }
          if (
            !(
              dado.tb_item_de_avaliacao.descricao in
              retorno[
                dado
                  .tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario
                  .nome
              ][dado.tb_item_de_avaliacao.tb_classificacao.descricao]
            )
          ) {
            retorno[
              // eslint-disable-next-line max-len
              dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario.nome
            ][dado.tb_item_de_avaliacao.tb_classificacao.descricao][
              dado.tb_item_de_avaliacao.descricao
            ] = {};
          }
          /* eslint-disable */
          retorno[
            dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadoTotb_usuario.nome
          ][dado.tb_item_de_avaliacao.tb_classificacao.descricao][
            dado.tb_item_de_avaliacao.descricao
          ][
            dado.tb_usuario_tb_avaliacao_item_id_usuario_avaliadorTotb_usuario.nome
          ] = dado.nota;
        });
        this.listaQuestoes = listaQuestoes;
        this.descricaoClassificacao = descricaoClassificacao;
        this.notasRecebidas = notasRecebidas;
        this.chavesAvaliados = nomeMembrosAvaliados;
        this.dados = retorno;
      } catch (error) {
        console.error(error);
      }
    },
    toggleCollapse(n) {
      this.isCollapsed[n] = !this.isCollapsed[n];
    },
  },
};
</script>

<style scoped>
.linha {
  border: 1px solid #707070;
}
</style>
